// ============================================================================
// EDMONDS-KARP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'edmonds-karp',
  name: 'Edmonds-Karp',
  category: 'Graphs',
  complexity: {
    time: 'O(VE²)',
    space: 'O(V²)'
  },
  description: 'An implementation of the Ford-Fulkerson method that uses BFS to find augmenting paths. It guarantees polynomial time complexity and is a specific case of the maximum flow problem.'
};
